import React from "react";
import Drawer from '@material-ui/core/Drawer';
import withStyles from "@material-ui/core/styles/withStyles";
const CoachDetailsDrawer = withStyles((theme) => ({

    paperAnchorRight: {
        left: '0',
        paddingBottom: '190px',
        height: '-webkit-fill-available'
    },
}))((props) => {
    return (
        <Drawer disableEnforceFocus transitionDuration={600} elevation={2} anchor={"right"} open={true} {...props}>
            {props.children}
        </Drawer>)
})

export default CoachDetailsDrawer;